export function createObservableStore<T>(initial: T) {
  let snapshot = initial;
  const listeners = new Set<() => void>();

  return {
    getSnapshot(): T {
      return snapshot;
    },
    subscribe(listener: () => void): () => void {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    setState(next: T | ((current: T) => T)): void {
      const value = typeof next === "function" ? (next as (current: T) => T)(snapshot) : next;
      if (Object.is(value, snapshot)) {
        return;
      }
      snapshot = value;
      for (const listener of listeners) {
        listener();
      }
    },
  };
}

export type ObservableStore<T> = ReturnType<typeof createObservableStore<T>>;
